export function getFirebaseAuthErrorMessage(
  error: any,
  fallback = "Something went wrong. Please try again.",
) {
  const errorCode = String(error?.code || "");

  if (
    errorCode === "auth/invalid-credential" ||
    errorCode === "auth/wrong-password" ||
    errorCode === "auth/user-not-found"
  ) {
    return "Incorrect email or password";
  }

  if (errorCode === "auth/invalid-email") {
    return "Please enter a valid email address";
  }

  if (errorCode === "auth/email-already-in-use") {
    return "This email is already registered";
  }

  if (errorCode === "auth/weak-password") {
    return "Password should be at least 6 characters";
  }

  if (errorCode === "auth/too-many-requests") {
    return "Too many attempts. Please try again later or reset your password.";
  }

  if (errorCode === "auth/network-request-failed") {
    return "Network error. Please check your internet connection and try again.";
  }

  if (errorCode === "auth/user-disabled") {
    return "This account has been disabled. Please contact the administrator.";
  }

  return fallback;
}

export function getFriendlyServerErrorMessage(
  error: any,
  fallback = "Something went wrong. Please try again.",
) {
  const message = String(error?.message || "").toLowerCase();

  if (!message) {
    return fallback;
  }

  if (
    message.includes("invalid credential") ||
    message.includes("wrong password") ||
    message.includes("incorrect password")
  ) {
    return "Incorrect email or password";
  }

  if (message.includes("email already")) {
    return "This email is already registered";
  }

  if (message.includes("weak password")) {
    return "Password should be at least 6 characters";
  }

  if (message.includes("reset key")) {
    return "The authorized reset key is incorrect";
  }

  return error?.message || fallback;
}
